import React, { Fragment } from 'react'
import { Route, Routes, BrowserRouter } from 'react-router-dom'
import { routes } from './routes'
import configTheme from '@modules/theme/scripts/configTheme'
import getUser from '@modules/auth/scripts/getUser'
import PageRender from '@components/Page/Render'
import configSidebar from '@components/Page/Sidebar/scripts/configSidebar'
import Error from '@modules/error/pages/Error'
import setError from '@modules/error/scripts/setError'
import errorRoutes from '@modules/error/routes'
import { useAppDispatch } from '@redux/hooks'
import ProtectedRoute from './components/ProtectedRoute'

const AppRoutes: React.FC = () => {

    const dispatch = useAppDispatch()

    configTheme(dispatch, true)
    configSidebar(dispatch)
    getUser(dispatch)
    
    return(

        <BrowserRouter>
            <Routes>
                {errorRoutes.map((route, index) => (
                    <Route key = {index} path = {route.path}>
                        {route.subRoutes?.map((subRoute, subIndex) => (
                            <Route
                                key = {subIndex}
                                path = {subRoute.path}
                                element = {<PageRender {...subRoute} title = {setError(subRoute.path).title}><Error idError = {subRoute.path} /></PageRender>}
                            />
                        ))}
                    </Route>
                ))}
                {routes.map((route, index) => (
                    <Fragment key = {index}>
                        {(route.subRoutes && (
                            <Route path = {route.path}>
                                {route.subRoutes.map((subRoute, subIndex) => (
                                    <Route key = {subIndex} path = {subRoute.path} element = {(() => {
                                        if(subRoute.userVerification) return <ProtectedRoute><PageRender {...subRoute} pageKey = {subRoute.key} /></ProtectedRoute>
                                        return <PageRender {...subRoute} pageKey = {subRoute.key} />
                                    })()} />
                                ))}
                            </Route>
                        )) || (
                            <Route path = {route.path} element = {(() => {
                                if(route.userVerification) return <ProtectedRoute><PageRender {...route} pageKey = {route.key} /></ProtectedRoute>
                                return <PageRender {...route} pageKey = {route.key} />
                            })()} />
                        )}
                    </Fragment>
                ))}
                <Route path = "*" element = {<Error idError = "http-404" />} />
            </Routes>
        </BrowserRouter>

    )

}

export default AppRoutes